import React, { useState, useEffect } from 'react';

const EditarRendimiento = (p) => {
    const original = { ...p.data };
    const inputs = { ...p.inputs };
    const [rendimiento, setrendimiento] = useState(p.data ? { ...p.data } : {
        "id": null,
        "area_id": 0,
        "labor_id": 0,
        "um_id": 0,
        "unidad_hora": 0
    });
    console.log(`rendimiento`, rendimiento)

    const changeValue = (event) => {
        let { name, value } = event.target;
        setrendimiento({ ...rendimiento, [name]: value });
    }

    const update = async (update, deleteReg = false) => {
        let data = {
            area: rendimiento.area_id,
            id: rendimiento.id,
            labor: rendimiento.labor_id,
            um: rendimiento.um_id,
            unidad_hora: rendimiento.unidad_hora,
            pago_unidad: rendimiento.pago_unidad,
            estado: rendimiento.estado
        }
        if (await p.update(data, update, deleteReg)) p.close();

    }

    return (
        <div className='vw-100 vh-100 blur-m bg-white5' style={{ position: "fixed", top: 0, left: 0, zIndex: 10 }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='w-100 text-end' style={{ position: "sticky", left: 0, top: 0, zIndex: 15 }}>
                    <button className='btn btn-danger shadow mt-3 me-3 round-xl border border-2 scale-continue-05' onClick={p.close}>Cerrar</button>
                </div>
                <div className='bw-1000 mt-3 p-2 bg-white3 blur-xxl shadow-multi round-s'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <div className='form-group bw-300 mt-2 mb-2'>
                            <label className='text-bold'>Nombre labor</label>
                            <select className='form-control shadow border' name='labor_id' value={rendimiento.labor_id} onChange={changeValue}>
                                {!p.data && <option key={0} value={0} >Seleccione una opción</option>}
                                {inputs.labores.map((l, i) => <option key={i + "labor"} value={l.id}>{l.labor}</option>)}

                            </select>
                        </div>

                        <div className='form-group bw-300 mt-2 mb-2'>
                            <label className='text-bold'>Área</label>
                            <select className='form-control shadow border' name='area_id' value={rendimiento.area_id} onChange={changeValue}>
                                <option value={0} >Seleccione área</option>
                                {inputs.areas.map((l, i) => <option key={i + "area"} value={l.id} >{l.nombre}</option>)}
                            </select>
                        </div>

                        <div className='form-group bw-300 mt-2 mb-2'>
                            <label className='text-bold'>Unidad de medida</label>
                            <select className='form-control shadow border' name='um_id' value={rendimiento.um_id} onChange={changeValue}>
                                <option value={0} >Seleccione unidad de medida</option>
                                {inputs.um.map((l, i) => <option key={i + "um"} value={l.id} >{l.nombre}</option>)}
                            </select>
                        </div>

                        <div className='form-group bw-300 mt-2 mb-2'>
                            <label className='text-bold'>Unidades por hora</label>
                            <input className='form-control shadow border'
                                type='number'
                                min={0}
                                name='unidad_hora' value={rendimiento.unidad_hora} onChange={changeValue} />
                        </div>
                        <div className='form-group bw-300 mt-2 mb-2'>
                            <label className='text-bold'>Pago por por unidad realizada</label>
                            <input className='form-control shadow border'
                                type='number'
                                min={0}
                                name='pago_unidad' value={rendimiento.pago_unidad} onChange={changeValue} />
                        </div>

                        <div className='form-group bw-300 mt-2 mb-2'>
                            <label className='text-bold'>Estado del rendimiento</label>
                            <select className='form-control shadow border' placeholder='' name='estado' value={rendimiento.estado} onChange={changeValue} >
                                <option value='ACTIVO' >Activo</option>
                                <option value='INACTIVO' >Inactivo</option>
                            </select>
                        </div>

                        {p.data && <div className='form-group bw-300 mt-2 mb-2 contenedor'>
                            <button className='btn btn-light text-red4 border border-danger shadow w-100'
                                onClick={() => setrendimiento({ ...original })}
                            >Restaurar valores originales</button>
                        </div>}

                        <div className='w-100 mt-4 mb-3 text-center'>
                            <div className='row justify-content-evenly w-100 m-0 p-0'>
                                {rendimiento.id && <button className='btn btn-danger bg-red3 text-white shadow text-bold border border scale-025 round-xxl bw-100'
                                    onClick={() => { update(false, true) }}
                                >Eliminar</button>}
                                {
                                    p.data && <button className='btn btn-warning shadow text-red4 text-bold border border scale-025 ps-5 pe-5 round-xxl bw-300'
                                        onClick={() => { update(false) }}
                                    >Guardar como nuevo registro</button>
                                }
                                <button className='btn btn-warning shadow text-red4 text-bold border border scale-025 ps-5 pe-5 round-xxl bw-200'
                                    onClick={() => { update(p.data ? true : false) }}
                                >{p.data ? "Guardar cambios" : "Crear registro"}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditarRendimiento;